interface Props {
  locales: string | string[]
  options?: Intl.DateTimeFormatOptions
}

const getWeekdaysForLocale = ({ locales, options }: Props): string[] => {
  const formatter = new Intl.DateTimeFormat(locales, options)
  const weekdays = Array.from(Array(7).keys())
  return weekdays.map(day => formatter.format(new Date(Date.UTC(2021, 5, day))))
}

export default getWeekdaysForLocale
